module.exports = __webpack_public_path__ + "img/mastercard.29cbd0e2.svg";